<div id="forgot-password" fusePerfectScrollbar class="fx-column">
  <div id="forgot-password-form-wrapper" class="fx-column fx-justify-center fx-items-center">
    <div class="form-wrapper">

      <div class="logo mb-32">
        <img src="assets/images/logos/tangerine_logo.png" />
      </div>

      <div
        id="forgot-password-form"
        *fuseIfOnDom
				[@animate]="{
					value: '*',
					params: { duration: '300ms', y: '100px' }
				}"
        >

        @if (sending) {
          <mat-progress-bar
            class="mt-24 mb-24"
            style="min-width:300px"
            mode="indeterminate"
          ></mat-progress-bar>
        }

        @if (sent) {
          <p class="green-fg">
            {{ 'FORGOT_PASSWORD.SENT' | translate }}
          </p>
        } @else {
          <p class="description">
            {{ 'FORGOT_PASSWORD.DESCRIPTION' | translate }}
          </p>

          <form
            name="forgotPasswordForm"
            [formGroup]="forgotPasswordForm"
            novalidate
            >
            <mat-form-field appearance="fill">
              <mat-label>{{ 'FORGOT_PASSWORD.EMAIL' | translate }}</mat-label>
              <input matInput formControlName="email" />
              <mat-icon matSuffix class="secondary-text">mail</mat-icon>
              @if (
                forgotPasswordForm.get('email').hasError('required')
                ) {
                <mat-error
                  >
                  {{ 'FORGOT_PASSWORD.ERROR.EMAIL_REQUIRED' | translate }}
                </mat-error>
              }
              @if (
                forgotPasswordForm.get('email').hasError('email')
                ) {
                <mat-error
                  >
                  {{ 'FORGOT_PASSWORD.ERROR.EMAIL_INVALID' | translate }}
                </mat-error>
              }
            </mat-form-field>

            @if (lastErrorMessage) {
              <p class="red-fg">
                {{ lastErrorMessage }}
              </p>
            }

            <button
              mat-flat-button
              (click)="onSendClick()"
              class="submit-button"
              color="accent"
              aria-label="SEND RESET LINK"
              [disabled]="forgotPasswordForm.invalid || sending"
              >
              <span>{{ 'FORGOT_PASSWORD.SEND' | translate }}</span>
              <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
            </button>
          </form>
        }

        <a
          class="login-link"
          [routerLink]="'/auth/login'"
          >
          {{ 'FORGOT_PASSWORD.BACK_TO_LOGIN' | translate }}
        </a>

      </div>
    </div>
  </div>
</div>
